import type { Annotations, AnnotationsAction } from './types';
import { AnnotationsActionEnum } from './types';

export const annotationReducer = (
  annotations: Annotations,
  action: AnnotationsAction
): Annotations => {
  switch (action.type) {
    case AnnotationsActionEnum.addComment:
      return annotations.map((a) =>
        a.id === action.payload.id
          ? { ...a, comment: action.payload.comment }
          : a
      ) as Annotations;
    case AnnotationsActionEnum.addAnnotation:
      var filtered = annotations.filter((a) => a.id !== -1);
      return [...filtered, action.payload];
    case AnnotationsActionEnum.setAnnotations:
      return action.payload;
    case AnnotationsActionEnum.updateAnnotationType:
      return annotations.map((a) =>
        a.id === action.payload.id
          ? { ...a, type: action.payload.annotationType }
          : a
      ) as Annotations;
    case AnnotationsActionEnum.resizeAnnotation:
      var { activeId, resizeHandle, x, y } = action.payload;
      var newState = annotations.map((a) => {
        if (a.id !== activeId) return a;
        let { x: ax, y: ay, width: aw, height: ah } = a;
        if (resizeHandle === 'tl') {
          const newX = Math.min(ax + aw - 1, x);
          const newY = Math.min(ay + ah - 1, y);
          const newW = ax + aw - newX;
          const newH = ay + ah - newY;
          return { ...a, x: newX, y: newY, width: newW, height: newH };
        }
        if (resizeHandle === 'tr') {
          const newX2 = Math.max(ax + 1, x);
          const newY = Math.min(ay + ah - 1, y);
          const newW = newX2 - ax;
          const newH = ay + ah - newY;
          return { ...a, y: newY, width: newW, height: newH };
        }
        if (resizeHandle === 'br') {
          const newX2 = Math.max(ax + 1, x);
          const newY2 = Math.max(ay + 1, y);
          const newW = newX2 - ax;
          const newH = newY2 - ay;
          return { ...a, width: newW, height: newH };
        }
        if (resizeHandle === 'bl') {
          const newX = Math.min(ax + aw - 1, x);
          const newY2 = Math.max(ay + 1, y);
          const newW = ax + aw - newX;
          const newH = newY2 - ay;
          return { ...a, x: newX, width: newW, height: newH };
        }
        return a;
      });
      return newState as Annotations;
    case AnnotationsActionEnum.moveAnnotation:
      var { activeId, dx, dy, naturalWidth, naturalHeight } = action.payload;
      var newState = annotations.map((a) => {
        if (a.id !== activeId) return a;
        const nx = Math.max(0, Math.min(naturalWidth - a.width, a.x + dx));
        const ny = Math.max(0, Math.min(naturalHeight - a.height, a.y + dy));
        return { ...a, x: nx, y: ny };
      });
      return newState as Annotations;
    case AnnotationsActionEnum.removeDraftAnnotation:
      var filtered = annotations.filter((a) => a.id !== -1);
      return filtered;
    case AnnotationsActionEnum.deleteAnnotation:
      var filtered = annotations.filter(
        (a) => a.id !== action.payload.activeId
      );
      return filtered;
    default:
      return annotations;
  }
};
